var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSushiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000084515081114863705070000003305186874971475878_);}\n\t.st2{fill:url(#SVGID_00000041280143185377472960000016135282561395724215_);}\n\t.st3{fill:url(#SVGID_00000112628847575890946700000000487561414362728064_);}\n\t.st4{fill:url(#SVGID_00000056403820322796732110000011360744757527687359_);}\n\t.st5{fill:url(#SVGID_00000089559917041025704250000004422217229349836214_);}\n\t.st6{fill:#0E0F23;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st8{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 718.4066,
    y1: 763.6495,
    x2: 289.4411,
    y2: 52.47,
    gradientTransform: "matrix(1 0 0 -1 -20.9449 718.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBEDC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,441.1C0.5,197.7,197.8,0.5,441.1,0.5s440.6,197.3,440.6,440.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095304864940716141990000015998348809516216739_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.6119,
    y1: 548.4366,
    x2: 233.6465,
    y2: -162.7429,
    gradientTransform: "matrix(1 0 0 -1 -20.9449 718.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBEDC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095304864940716141990000015998348809516216739_)"
    },
    d: "M881.7,441.1 c0,243.3-197.3,440.6-440.6,440.6S0.5,684.4,0.5,441.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129188724894385777130000005811331389939480459_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.2292,
    y1: 569.8515,
    x2: 449.1006,
    y2: 319.6205,
    gradientTransform: "matrix(1 0 0 -1 -20.9449 718.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA52A0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129188724894385777130000005811331389939480459_)"
    },
    d: "M142,362.9l118.3-172.1l478.1,326.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088110725120195631130000018094821892235924641_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.1846,
    y1: 420.33,
    x2: 408.4612,
    y2: 168.7075,
    gradientTransform: "matrix(1 0 0 -1 -20.9449 718.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA52A0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088110725120195631130000018094821892235924641_)"
    },
    d: "M620.1,692L142,362.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008118635697714433590000000421361149077092543_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.7502,
    y1: 596.5467,
    x2: 547.5679,
    y2: 270.9609,
    gradientTransform: "matrix(1 0 0 -1 -20.9449 718.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA52A0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008118635697714433590000000421361149077092543_)"
    },
    d: "M738.4,517.3c-41,59.2-179.9,36.1-311-56.6 c-133.7-90-205.6-210.8-167.1-269.9c41-59.2,179.9-36.1,310.9,56.6C704.9,334.8,777,458.2,738.4,517.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130607384179274517350000005606315106363040384_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.3814,
    y1: 551.5924,
    x2: 393.1992,
    y2: 226.0068,
    gradientTransform: "matrix(1 0 0 -1 -20.9449 718.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA52A0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130607384179274517350000005606315106363040384_)"
    },
    d: "M620.3,689.6c-41,59.2-179.9,36.1-311-56.6 S103.7,422.3,144.8,360.5c41-59.2,179.9-36.1,311,56.6C586.8,509.5,658.7,630.5,620.3,689.6"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M620.1,692c-41,59.2-179.9,33.5-311-56.6c-25.7-17.9-48.8-36.1-71.9-56.6c17.9-2.6,41-12.9,64.3-38.6 c41-43.6,61.8-54,79.7-51.4c17.9,0,38.6,17.9,71.9,61.8c33.5,43.6,79.7,56.6,108,33.5c2.6-2.6,5.2-2.6,7.8-5.2 c23.1-17.9,30.9-25.7,74.5-108"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M720.4,507.2c-36.1,51.4-161.9,25.7-282.7-59.2c-123.2-84.9-195.3-192.8-159.3-244.2s161.9-25.7,282.7,59.2 S753.9,455.6,720.4,507.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M607.3,429.9c-17.9,25.7-79.7,12.9-141.4-28.3c-59.2-41-95-95-77.1-120.7s79.7-12.9,141.4,28.3 C589.4,350.2,625.2,404.2,607.3,429.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.9,250c0-2.6-2.6-5.2-5.2-2.6c-2.6,2.6-5.2,2.6-5.2,5.2c2.6,7.8,5.2,12.9,5.2,17.9c0,2.6,2.6,5.2,5.2,2.6 c2.6,0,5.2-2.6,2.6-5.2C252.5,262.9,252.5,257.8,249.9,250z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M262.9,291.2c0-2.6-2.6-5.2-5.2-2.6s-2.6,2.6-2.6,5.2c28.3,64.3,87.4,133.7,164.5,185.1c2.6,2.6,5.2,0,7.8,0 c2.6-2.6,0-5.2,0-7.8C347.7,419.7,291.2,352.8,262.9,291.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M599.5,550.8c-7.6-2.6-17.9-5.2-25.7-7.8c-2.6,0-5.2,0-5.2,2.6s0,5.2,2.6,5.2c7.8,2.6,17.9,5.2,25.7,7.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushiIcon);
export default __webpack_public_path__ + "static/media/sushi_icon.afd5be8a30ffa07d3c3c7f5758104707.svg";
export { ForwardRef as ReactComponent };